import React, { useContext, useEffect, useRef, useMemo } from "react";
import { ArticleContext } from "../../contexts/ArticleContext"; // Ajuste selon ton projet
import { Link } from "react-router-dom";

export default function CarouselsHeader() {
  const { articles } = useContext(ArticleContext);
  const carouselRef = useRef(null);

  const categories = [
    {
      banner:
        "https://plus.unsplash.com/premium_photo-1675252369719-dd52bc69c3df?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Zm9vZHxlbnwwfHwwfHx8MA%3D%3D",
      link: "/allProducts/Restauration",
    },
    {
      banner:
        "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc4/apple_iphone_16_pro_max_vs_samsung_s24_ultra_camera_comparision_youtube.JPG",
      link: "/allProducts/Telephone%20et%20tablette",
    },
    {
      banner:
        "https://images.unsplash.com/photo-1559563458-527698bf5295?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8YmFnJTIwZm9yJTIwd29tZW58ZW58MHx8MHx8fDA%3D",
      link: "/allProducts/Femme",
    },
    {
      banner:
        "https://images.unsplash.com/photo-1663044022726-889ee51a682e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTJ8fGFmcmljYW4lMjBtZW4lMjBmYXNoaW9ufGVufDB8fDB8fHww",
      link: "/allProducts/Homme",
    },
  ];

  return (
    <div className="bg-white mb-12">
      <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
        <div className="mt-10 grid gap-4 sm:mt-16 lg:grid-cols-3 lg:grid-rows-2">
          <div className="relative lg:row-span-2">
            <Link to={categories[1].link}>
              <img
                src={categories[1].banner}
                alt=""
                className="rounded-lg object-cover h-52 sm:h-96 w-full cursor-pointer"
              />
              <p className="absolute left-2 bottom-8 sm:bottom-24 text-white text-xl sm:text-4xl font-bold">
                Smartphone & Hightech
              </p>
            </Link>
          </div>
          <div className="relative max-lg:row-start-1">
            <Link to={categories[0].link}>
              <img
                src={categories[0].banner}
                alt=""
                className="rounded-lg object-cover h-52 w-full cursor-pointer"
              />
              <p className="absolute z-30 left-4 bottom-8 text-white text-xl sm:text-4xl font-bold">
                Foods
              </p>
            </Link>
          </div>
          <div className="relative max-lg:row-start-3 lg:col-start-2 lg:row-start-2">
            {" "}
            <Link to={categories[3].link}>
              <img
                src={categories[3].banner}
                alt=""
                className="rounded-lg object-cover h-52 w-full cursor-pointer"
              />
              <p className="absolute left-4 bottom-8 text-white text-xl sm:text-4xl font-bold">
                Mode Hommes
              </p>
            </Link>
          </div>
          <div className="relative lg:row-span-2">
            <Link to={categories[2].link}>
              <img
                src={categories[2].banner}
                alt=""
                className="rounded-lg object-cover h-52 sm:h-96 w-full cursor-pointer"
              />
              <p className="absolute left-4 bottom-8 sm:bottom-24 text-white text-xl sm:text-4xl font-bold">
                Mode Femmes
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
